module.exports = __webpack_public_path__ + "static/media/icon_arrow_down.cbeb5008.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_arrow_down.svg
// module id = 1168
// module chunks = 0